import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const CancelDialog = ({
  open,
  onConfirm,
  onClose,
  t,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={"xs"}
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 18px 38px rgba(15, 23, 42, 0.24)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        id="counter-cancel-dialog-title"
        sx={{
          m: 0,
          px: 3,
          py: 2.5,
          background: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
          color: "#ffffff",
          fontWeight: 700,
          fontSize: "1.15rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        {t("Console.CancelConfirmationTitle", {
          defaultValue: "Cancel this order?",
        })}
        <IconButton
          aria-label={t("Global.Close") || "Close"}
          onClick={onClose}
          sx={{
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.18)",
            },
          }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          px: 3,
          pt: 3,
          pb: 2,
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            gap: 1.5,
          }}
        >
          <ErrorOutlineIcon sx={{ fontSize: "1.6rem", color: "#d97706", mt: 0.25 }} />
          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, color: "#1e293b", mb: 0.75 }}
            >
              {t("Console.AreYouSureToCancelOrder")}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions
        sx={{
          px: 3,
          py: 2.5,
          backgroundColor: "#f8fafc",
          borderTop: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "flex-end",
          gap: 1.5,
        }}
      >
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{
            minWidth: "120px",
            minHeight: "43px",
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
            boxShadow: "0 8px 18px rgba(239, 68, 68, 0.35)",
            "&:hover": {
              background: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
              boxShadow: "0 10px 24px rgba(239, 68, 68, 0.4)",
            },
          }}
        >
          {t("Console.YES")}
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            minWidth: "120px",
            minHeight: "43px",
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 600,
            borderWidth: 2,
            borderColor: "#cbd5f5",
            color: "#1e293b",
            "&:hover": {
              borderColor: "#a5b4fc",
              backgroundColor: "rgba(165, 180, 252, 0.12)",
            },
          }}
        >
          {t("Console.NO")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CancelDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default CancelDialog;





// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/counter/dialogs/CancelDialog.jsx